import styled from 'styled-components';
import { IconSmallUsersLegacy, IconSmallPublicLegacy, IconSmallChartsLegacy, IconSmallEditLegacy, IconSmallCodeLegacy, IconSmallSettingsLegacy, IconSmallPlusLegacy, IconSmallHiddenNewLegacy, IconSmallCopyLegacy, IconSmallReuseLegacy, IconSmallLinkLegacy, IconSmallArrowLineLeftLegacy, IconSmallWarningLegacy, IconSmallTrashLegacy } from '@prezi/common-design';
const generateStyledIcon = Icon => {
  const StyledIcon = styled(Icon).withConfig({
    displayName: "icons__StyledIcon",
    componentId: "gqvmx1-0"
  })(["path{fill:", "};}"], ({
    fill,
    theme
  }) => fill || theme.bento.colors.text.main);
  StyledIcon.displayName = Icon.displayName || Icon.name || 'Component';
  return StyledIcon;
};
export const Users = generateStyledIcon(IconSmallUsersLegacy);
export const Public = generateStyledIcon(IconSmallPublicLegacy);
export const Charts = generateStyledIcon(IconSmallChartsLegacy);
export const Edit = generateStyledIcon(IconSmallEditLegacy);
export const Code = generateStyledIcon(IconSmallCodeLegacy);
export const Settings = generateStyledIcon(IconSmallSettingsLegacy);
export const Plus = generateStyledIcon(IconSmallPlusLegacy);
export const HiddenNew = generateStyledIcon(IconSmallHiddenNewLegacy);
export const Copy = generateStyledIcon(IconSmallCopyLegacy);
export const Reuse = generateStyledIcon(IconSmallReuseLegacy);
export const Link = generateStyledIcon(IconSmallLinkLegacy);
export const ArrowLeft = generateStyledIcon(IconSmallArrowLineLeftLegacy);
export const Warning = generateStyledIcon(IconSmallWarningLegacy);
export const Trash = generateStyledIcon(IconSmallTrashLegacy);